import React, { Component, Fragment } from "react";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import I18n from "pages/_components/I18n";
import Container from "pages/_components/Container";
import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import * as configUtils from "util/config";
import ViewTitle from "./header/components/ViewTitle";

class SupportInfo extends Component {
    backButtonAction = () => {
        const { history } = this.props;
        history.goBack();
    };

    render() {
        const urlSupportConfig = configUtils.get("general.support.url", "www.bibank.com.ar");
        const urlSupport = `https://${urlSupportConfig}`;
        return (
            <Fragment>
                <MainContainer>
                    <Container>
                        <Col xs={12}>
                            <Head title="global.termAndConditions" onClose={this.backButtonAction} />
                            <ViewTitle id="global.support" />
                        </Col>
                    </Container>
                    <Grid className="form-content">
                        <Row className="justify-content-center" style={{ textAlign: "justify" }}>
                            <Col className="col-12 scrollable-content">
                                <I18n id="general.support.text1" />
                            </Col>
                        </Row>
                        <Row className="justify-content-center mt-7">
                            <Col className="col-12 scrollable-content">
                                <I18n id="general.support.text2" />
                            </Col>
                        </Row>
                        <Row className="justify-content-center mt-7">
                            <Col className="col-12 scrollable-content">
                                <I18n id="general.support.text3" />
                            </Col>
                        </Row>
                        <Row className="justify-content-center mt-7" style={{ textAlign: "center" }}>
                            <Col className="col-12 scrollable-content">
                                <I18n id="general.support.text4" />
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col className="col-12 text-center mt-7">
                                <a href={urlSupport} target="_blank" rel="noreferrer">
                                    {urlSupportConfig}
                                </a>
                            </Col>
                        </Row>
                    </Grid>
                </MainContainer>
            </Fragment>
        );
    }
}

export default SupportInfo;
